// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum CollaborationState {
  Open = 0,
  Locked = 1,
  Edit = 2,
  NonCollaborative = 3,
}
